import React from "react";

function StatCard({ label, value, valueColor }) {
  return (
    <div className="bg-white border border-[#E5E7EB] rounded-xl shadow-sm py-6 px-4 flex flex-col items-center justify-center text-center">
      <p className={`text-3xl font-bold leading-tight ${valueColor}`}>{value}</p>
      <p className="text-sm text-[#6B7280] mt-1">{label}</p>
    </div>
  );
}

export default function StatsCards({ stats }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <StatCard label="Total Patients" value={stats?.total_cases ?? 0} valueColor="text-[#DC2626]" />
      <StatCard label="Reported Cases" value={stats?.reported_cases ?? 0} valueColor="text-[#16A34A]" />
      <StatCard label="Pending Cases" value={stats?.pending_cases ?? 0} valueColor="text-[#D97706]" />
    </div>
  );
}